// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"355a9e57","631":"355a9e57","988":"f6e6bf67"}[chunkId] + ".chunk.css";
};